import { createSelector } from "@reduxjs/toolkit";
import { wishlistApi } from "./api/wishlistApi";

// 1. Create a base "input selector" to get the query result object from the API cache.
const selectWishlistResult = wishlistApi.endpoints.getWishlist.select();

// 2. Create a memoized selector to get the array of item IDs from the query's data.
// This will only return a new array reference if the `data` has actually changed.
export const selectWishlistItems = createSelector(
  [selectWishlistResult],
  (wishlistResult) => wishlistResult.data ?? [] // Fallback to an empty array
);

// 3. Create a memoized selector that derives the count from the item IDs array.
// This calculation will only re-run if `selectWishlistItems` returns a new value.
export const selectWishlistCount = createSelector(
  [selectWishlistItems],
  (itemIds) => itemIds.length
);

// 4. Create a selector factory for checking if a specific item is in the wishlist.
// This pattern is efficient for passing arguments to selectors.
export const selectIsInWishlist = (productId: number) =>
  createSelector([selectWishlistItems], (itemIds) =>
    itemIds.includes(productId)
  );
